// @ts-nocheck
import React, { useEffect } from 'react';
import { Spinner, IconRefresh } from 'takeat-design-system-ui-kit';
import useWhatsappStore from '~/store/whatsappStore';
import Sheet from '../../Sheet';
import { TabsHeader, ConnectionTab, AITab } from './Tabs';

export default function WhatsappSheet({
  open,
  onClose,
  isValidQrCode,
  countdown,
  COUNTDOWN_TIME,
  user,
  onRefresh,
}) {
  const {
    wppConnected,
    wppStatus,
    phoneDetails,
    loadingQrCode,
    logoutWpp,
    createInstance,
    wppQrcode,
    waitingForWebhook,
  } = useWhatsappStore((s) => ({
    wppConnected: s.wppConnected,
    wppStatus: s.wppStatus,
    phoneDetails: s.phoneDetails,
    loadingQrCode: s.loadingQrCode,
    logoutWpp: s.logoutWpp,
    createInstance: s.createInstance,
    wppQrcode: s.wppQrcode,
    waitingForWebhook: s.waitingForWebhook,
  }));

  const [isRefreshing, setIsRefreshing] = React.useState(false);
  const handleHeaderRefresh = async () => {
    // Delegate refresh to prop if provided so parent (WhatsappButton) controls fetching
    setIsRefreshing(true);
    try {
      if (typeof onRefresh === 'function') await onRefresh();
    } finally {
      setIsRefreshing(false);
    }
  };

  // Note: instance querying is now handled by the parent component via `onRefresh`.

  const isConnected = wppStatus === 'open';
  const [activeTab, setActiveTab] = React.useState('connection');

  // @ts-ignore - allow using JS-based Sheet component in TS-checked environment
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title="Conexão com o Whatsapp"
      headerRight={
        <button
          type="button"
          onClick={handleHeaderRefresh}
          disabled={isRefreshing}
          aria-label="refresh"
          style={{
            background: 'transparent',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 6,
            marginRight: 4,
            cursor: isRefreshing ? 'not-allowed' : 'pointer',
          }}
        >
          {isRefreshing ? (
            <Spinner size={18} />
          ) : (
            <IconRefresh style={{ fontSize: 18, fill: '#7A7A7A' }} />
          )}
        </button>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <TabsHeader activeTab={activeTab} onChange={setActiveTab} />
        {activeTab === 'connection' ? (
          <ConnectionTab
            phoneDetails={phoneDetails}
            wppStatus={wppStatus}
            wppQrcode={wppQrcode}
            countdown={countdown}
            COUNTDOWN_TIME={COUNTDOWN_TIME}
            isValidQrCode={isValidQrCode}
            loadingQrCode={loadingQrCode}
            waitingForWebhook={waitingForWebhook}
            createInstance={createInstance}
            logoutWpp={logoutWpp}
            user={user}
            onOpenAiTab={() => setActiveTab('ai')}
          />
        ) : (
          <AITab />
        )}
      </div>
    </Sheet>
  );
}
